import * as t from './header.types';

export const specifyTitle = (title) => ({
    type: t.SPECIFY_TITLE,
    payload: {
    	title
    }
});